import { Apr1Events } from "../../ui/Apr1";

export function apr1(): undefined {
  Apr1Events.emit();
}
